export const MIN_COUNT_PER_PAGE = 10;
export const MAX_COUNT_PER_PAGE = 20;
export const INCREASE_COUNT_PER_PAGE = 5;
